import React, { useEffect,  useRef, useState } from "react";

import { Row, Col, Offcanvas, Button } from "react-bootstrap";
import Cookies from "js-cookie";
import FASFilterBox from "../../../../../components/FilterBox/FASFilter/FASFilter";

import { format } from "date-fns";

import FASTable from "../../../../../components/Tables/FASTable";
import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { FiMenu } from "react-icons/fi";
import {
  SaleBook,
  SaleParty,
  SalesAnylysis,
} from "../../../../../Redux/Slice/Fas/DayBook Analysis/Sale/SaleSlice";
import { FilterMain } from "../../../../../Redux/Slice/login/loginSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";
import Calendar from "react-calendar";
import FASCalender from "../../../../../components/Calendar/FASCalender";

export const MonthWisePartyWiseSale = () => {
  const dispatch = useDispatch();
  const { Colourdata, DataMain, mainFilterData } = useSelector(
    (state) => state.ClientLogin,
  );
  const { SaleBookdata, SalePartydata, SalesAnylysisdata } = useSelector(
    (state) => state.SaleSlice,
  );

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");
  let YearId = Cookies.get("FinancialYear");

  const [showFilter, setShowFilter] = useState(false);
  const handleClose = () => setShowFilter(false);
  const handleShow = () => setShowFilter(true);
  const [activeTable, setActiveTable] = useState("MonthWise Sales");

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
  const [filters, setFilters] = useState({
    saleBook: [],
    productionGroup: [],
    saleParty: [],
  });
  const [search, setSearch] = useState({
    saleBook: "",
    productionGroup: "",
    saleParty: "",
  });
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showDateFilter, setShowDateFilter] = useState(true);
  const [isFilterLoading, setIsFilterLoading] = useState(false);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return "";
    return format(new Date(date), "yyyy-MM-dd");
  };

  useEffect(() => {
    dispatch(SaleBook({ Firm, Year: YearId }));
    dispatch(SaleParty({ Firm, Year: YearId }));
    dispatch(FilterMain({ Firm, Year: YearId }));
    dispatch(
      SalesAnylysis({
        Firm,
        Year: YearId,
        selectestartdate: safeFormat(startDate),
        selectenddate: safeFormat(endDate),
      }),
    );
  }, [dispatch, Firm, YearId]);

  const saleBookList =
    SaleBookdata?.BookName?.map((item) => ({
      label: item?.BookName,
      value: item?.BookId,
    })) || [];
  const salePartyList =
    SalePartydata?.BookName?.map((item) => ({
      label: item?.AcName,
      value: item?.AcID,
    })) || [];

  const productionList =
    mainFilterData?.production_Group_Master_List?.map((item) => ({
      label: item?.ProductionGroupMstName,
      value: item?.ProductionGroupMstID,
    })) || [];

  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };
  const toggleItem = (type, item) => {
    setFilters((prev) => {
      const selected = prev[type] || [];

      const alreadySelected = selected.includes(item.value);

      return {
        ...prev,
        [type]: alreadySelected ? [] : [item.value],
      };
    });
  };

  const applyFilter = async () => {
    setIsFilterLoading(true);

    try {
      await dispatch(
        SalesAnylysis({
          Firm,
          Year: YearId,
          selectePdGroupdIds: filters.productionGroup?.toString() || "",
          selecteBookdIds: filters.saleBook?.toString() || "",
          selectSalepartyIds: filters.saleParty?.toString() || "",
          selectestartdate: safeFormat(startDate),
          selectenddate: safeFormat(endDate),
        }),
      );
    } finally {
      setIsFilterLoading(false);
    }
  };

  const monthwisesalesRows = () => {
    return (
      SalesAnylysisdata?.MonthSumm?.map((item, index) => ({
        srNumber: index + 1,
        ...item,
      })) || []
    );
  };

  const monthwisesalesColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Month",
      key: "MonthName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Meter",
      key: "Meter",
      align: "right",
      format: "true",
    },
    { label: "PCS", key: "Pcs", align: "right", format: "true" },
    {
      label: "Amount",
      key: "Amount",
      align: "right",
      format: "true",
    },
  ];

  // Data for the table PartywiseSalesRows
  const PartywiseSalesRows = () => {
    return (
      SalesAnylysisdata?.PartySumm?.map((item, index) => ({
        // srNumber: index + 1,
        ...item,
      })) || []
    );
  };

  const PartywiseSalesColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Party",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Meter",
      key: "Meter",
      align: "right",
      format: "true",
    },
    { label: "PCS", key: "Pcs", align: "right", format: "true" },
    {
      label: "Net Amount",
      key: "Amount",
      align: "right",
      format: "true",
    },
  ];

  const MonthwiseSalesRows = () => {
    return (
      SalesAnylysisdata?.Detail?.map((item, index) => ({
        // srNumber: index + 1,

        AcName: item.AcName,
        Total: item.Total,
        AprAmt: item.AprAmt,
        MayAmt: item.MayAmt,
        JunAmt: item.JunAmt,
        JulAmt: item.JulAmt,
        AugAmt: item.AugAmt,
        SepAmt: item.SepAmt,
        OctAmt: item.OctAmt,
        NovAmt: item.NovAmt,
        DecAmt: item.DecAmt,
        JanAmt: item.JanAmt,
        FebAmt: item.FebAmt,
        MarAmt: item.MarAmt,
      })) || []
    );
  };

  const MonthwiseSalesColumns = [
    { label: "Chart", key: "charts", align: "center" },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Party",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Total Amount",
      key: "Total",
      format: "true",
      align: "right",
    },
    {
      label: "April",
      key: "AprAmt",
      format: "true",
      align: "right",
    },
    { label: "May", key: "MayAmt", format: "true", align: "right" },
    { label: "June", key: "JunAmt", format: "true", align: "right" },
    { label: "July", key: "JulAmt", format: "true", align: "right" },
    {
      label: "August",
      key: "AugAmt",
      format: "true",
      align: "right",
    },
    {
      label: "September",
      key: "SepAmt",
      format: "true",
      align: "right",
    },
    {
      label: "October",
      key: "OctAmt",
      format: "true",
      align: "right",
    },
    {
      label: "November",
      key: "NovAmt",
      format: "true",
      align: "right",
    },
    {
      label: "December",
      key: "DecAmt",
      format: "true",
      align: "right",
    },
    {
      label: "January",
      key: "JanAmt",
      format: "true",
      align: "right",
    },
    {
      label: "February",
      key: "FebAmt",
      format: "true",
      align: "right",
    },
    {
      label: "March",
      key: "MarAmt",
      format: "true",
      align: "right",
    },
  ];

  const isLoading =
    !SaleBookdata || !SalePartydata || !SalesAnylysisdata || isFilterLoading;

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div
      style={{
        padding: "16px",
        background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        minHeight: "100vh",
      }}
    >
      {/* MOBILE BUTTON */}
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={handleShow}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>

      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        placement="start"
        style={{
          background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title
            style={{ color: isdark === "light" ? "#000" : "#fff" }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "16px" }}
          >
            {showDateFilter && (
              <div>
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour10,
                    padding: "13px 20px",
                    borderRadius: "10px 10px 0px 0px",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "700",
                      fontSize: "18px",
                      margin: 0,
                      color:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour1,
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    {" "}
                    Date Range
                  </h3>
                </div>
                <div
                  style={{
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour10}`,
                    padding: "15px",
                    marginBottom: "15px",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1,
                    borderRadius: "0px 0px 10px 10px",
                  }}
                >
                  <div
                    onClick={() => setShowDatePicker(true)}
                    style={{
                      marginTop: "8px",
                      padding: "10px",
                      border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour10}`,
                      borderRadius: "8px",
                      cursor: "pointer",
                      color:
                        isdark === "light" ? "#000" : iscolourDark?.Colour11,
                      textAlign: "center",
                    }}
                  >
                    {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                      ? `${format(dateRange[0].startDate, "dd-MM-yyyy")} - ${format(dateRange[0].endDate, "dd-MM-yyyy")}`
                      : "Select Date Range"}
                  </div>
                </div>
              </div>
            )}
            <FASFilterBox
              title="Sale Books"
              items={saleBookList}
              search={search.saleBook}
              setSearch={(val) => handleSearch("saleBook", val)}
              selectedItems={filters.saleBook}
              toggleItem={(item) => toggleItem("saleBook", item)}
              selectAll={() => selectAll("saleBook", saleBookList)}
            />

            <FASFilterBox
              title="Production Groups"
              items={productionList}
              search={search.productionGroup}
              setSearch={(val) => handleSearch("productionGroup", val)}
              selectedItems={filters.productionGroup}
              toggleItem={(item) => toggleItem("productionGroup", item)}
              selectAll={() => selectAll("productionGroup", productionList)}
            />

            <FASFilterBox
              title="Sale Party"
              items={salePartyList}
              search={search.saleParty}
              setSearch={(val) => handleSearch("saleParty", val)}
              selectedItems={filters.saleParty}
              toggleItem={(item) => toggleItem("saleParty", item)}
              selectAll={() => selectAll("saleParty", salePartyList)}
            />
            <Button
              onClick={applyFilter}
              style={{
                width: "100%",
                height: "44px",
                borderRadius: "10px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour10,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour3,
                border: "none",
                fontWeight: "600",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <Row className="g-4">
        {/* FILTER */}
        <Col xl={3} lg={4} className="d-none d-lg-block">
          <div style={{ position: "sticky", top: "16px" }}>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "16px" }}
            >
              {showDateFilter && (
                <div>
                  <div
                    style={{
                      backgroundColor:
                        isdark === "light"
                          ? iscolour?.Colour5
                          : iscolourDark?.Colour10,
                      padding: "13px 20px",
                      borderRadius: "10px 10px 0px 0px",
                    }}
                  >
                    <h3
                      style={{
                        fontWeight: "700",
                        fontSize: "18px",
                        margin: 0,
                        color:
                          isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour1,
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      {" "}
                      Date Range
                    </h3>
                  </div>
                  <div
                    style={{
                      border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour10}`,
                      padding: "15px",
                      marginBottom: "15px",
                      background:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour1,
                      borderRadius: "0px 0px 10px 10px",
                    }}
                  >
                    <div
                      onClick={() => setShowDatePicker(true)}
                      style={{
                        marginTop: "8px",
                        padding: "10px",
                        border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour10}`,
                        borderRadius: "8px",
                        cursor: "pointer",
                        color:
                          isdark === "light" ? "#000" : iscolourDark?.Colour11,
                        textAlign: "center",
                      }}
                    >
                      {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                        ? `${format(dateRange[0].startDate, "dd-MM-yyyy")} - ${format(dateRange[0].endDate, "dd-MM-yyyy")}`
                        : "Select Date Range"}
                    </div>
                  </div>
                </div>
              )}
              <FASFilterBox
                title="Sale Books"
                items={saleBookList}
                search={search.saleBook}
                setSearch={(val) => handleSearch("saleBook", val)}
                selectedItems={filters.saleBook}
                toggleItem={(item) => toggleItem("saleBook", item)}
                selectAll={() => selectAll("saleBook", saleBookList)}
              />

              <FASFilterBox
                title="Production Groups"
                items={productionList}
                search={search.productionGroup}
                setSearch={(val) => handleSearch("productionGroup", val)}
                selectedItems={filters.productionGroup}
                toggleItem={(item) => toggleItem("productionGroup", item)}
                selectAll={() => selectAll("productionGroup", productionList)}
              />

              <FASFilterBox
                title="Sale Party"
                items={salePartyList}
                search={search.saleParty}
                setSearch={(val) => handleSearch("saleParty", val)}
                selectedItems={filters.saleParty}
                toggleItem={(item) => toggleItem("saleParty", item)}
                selectAll={() => selectAll("saleParty", salePartyList)}
              />
              <Button
                onClick={applyFilter}
                style={{
                  width: "100%",
                  height: "44px",
                  borderRadius: "10px",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour5
                      : iscolourDark?.Colour10,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour3,
                  border: "none",
                  fontWeight: "600",
                }}
                className="common-hover-btn"
              >
                Apply Filters
              </Button>
            </div>
          </div>
        </Col>

        {/* CONTENT */}
        <Col xl={9} lg={8} md={12}>
          <Row>
            <Col xl={12}>
              <div
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour4,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour11,
                    padding: "14px",
                  }}
                >
                  <h2
                    style={{
                      fontSize: "18px",
                      margin: 0,
                      letterSpacing: "1px",
                      fontWeight: "600",
                    }}
                  >
                    MONTHWISE PARTYWISE SALES
                  </h2>
                </div>

                <FASTable
                  data={MonthwiseSalesRows()}
                  columns={MonthwiseSalesColumns}
                />
              </div>

              <div style={{ display: "flex", gap: "12px", margin: "15px 0" }}>
                {["MonthWise Sales", "PartyWise Sales"].map((btn) => (
                  <button
                    key={btn}
                    onClick={() => setActiveTable(btn)}
                    style={{
                      flex: 1,
                      height: "50px",
                      borderRadius: "12px",
                      cursor: "pointer",
                      fontWeight: "600",
                      border: `2px solid ${
                        isdark === "light"
                          ? iscolour?.Colour5
                          : iscolourDark?.Colour10
                      }`,
                      background:
                        activeTable === btn
                          ? isdark === "light"
                            ? iscolour?.Colour5
                            : iscolourDark?.Colour10
                          : isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour4,
                      color:
                        activeTable === btn
                          ? isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour1
                          : isdark === "light"
                            ? iscolour?.Colour12
                            : iscolourDark?.Colour11,
                    }}
                  >
                    {btn}
                  </button>
                ))}
              </div>

              {/* ✅ HEADING */}
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour5
                      : iscolourDark?.Colour4,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour11,
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                  padding: "14px",
                }}
              >
                <h5
                  style={{
                    fontSize: "18px",
                    margin: 0,
                    letterSpacing: "1px",
                    fontWeight: "600",
                  }}
                >
                  {activeTable === "MonthWise Sales"
                    ? "MONTHWISE SALES"
                    : "PARTYWISE SALES"}
                </h5>
              </div>

              <div
                style={{
                  borderBottomLeftRadius: "12px",
                  borderBottomRightRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                }}
              >
                <FASTable
                  data={
                    activeTable === "MonthWise Sales"
                      ? monthwisesalesRows()
                      : PartywiseSalesRows()
                  }
                  columns={
                    activeTable === "MonthWise Sales"
                      ? monthwisesalesColumns
                      : PartywiseSalesColumns
                  }
                />
              </div>
            </Col>
            <Col xs={12}>{/* ✅ BUTTONS */}</Col>
          </Row>
        </Col>
      </Row>
      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <FASCalender
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "15px",
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour3,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour12
                      : iscolourDark?.Colour7,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
